import css from '@styled-system/css'
import styled from 'styled-components'

import Box from '@/ui/Box'

const SnackbarContainer = styled(Box)(
  css({
    position: 'fixed',
    insetInlineEnd: 6,
    top: 20,
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1145,
    padding: 2,
    gap: 2,
  }),
)

SnackbarContainer.displayName = 'SnackbarContainer'

export default SnackbarContainer
